/*******************************************************************************
CHARTIST DATA PROCESSING
This returns a function that can be used to manipulate a chart's data set.
*******************************************************************************/

export default function onData(options = {}) {
    const {
        flipDataSign = false,
    } = options;

    return (context) => {
        context.data.series = context.data.series.map(series => series.map((data) => {
            if (flipDataSign) { data.value = -data.value; }
            return data;
        }));
    };
    //TEST
}
